
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import Container from '@mui/material/Container/Container';
import Box from '@mui/material/Box/Box';

export const Loading = () => {
    return <Container>
        <Box sx={{ mt: 4 }} display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
            <CircularProgress color='secondary' />
        </Box>
    </Container>;
};
